<template>
    <div v-loading="loading">
        <el-form ref="form" :model="form" label-width="110px" id="feedback-form" :rules="rules">
            <el-form-item label="选择车型:" prop="inputList">
                <carSearch v-on:increment="appAddCounter" v-bind:inputList.sync="row" v-bind:searchType="3"></carSearch>
<!--                <el-cascader
                        placeholder="请选择"
                        v-model="inputList"
                        :options="options"
                        clearable
                        filterable
                        @change="handleChange"></el-cascader>-->
            </el-form-item>
            <el-form-item label="出口价:" prop="model_price_true">
                <el-input v-model="form.model_price_true"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSubmit()">提交</el-button>
                <el-button @click="close(2)">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import carSearch from '../../components/car-search/car-search'
    export default {
        name: "car-price-log-form",
        components:{
          carSearch
        },
        props: {
            layerid:String,
            edit: Boolean,
            seriesid:Number,
            row:{
                default:function () {
                    return [];
                }
            }
        },
        data(){
            let data = {
                form:{
                    'brandid':'','seriesid':'','modelid':''
                },
                loading:false,
                rules:{
                    modelid: [
                        { required: true, message: '请选择车系', trigger: 'change' },
                    ]
                },
                options: [],
                inputList:[],
            };
            return data;
        },
        mounted(){
            if(this.seriesid)this.form.seriesid = this.seriesid;
            if(this.edit){
                this.bt = '修改';
                this.form = this.row;
            }
        },
        methods:{
            onSubmit(e){
                this.form.type = 1;//手动上传数据
                let data = this.form;
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit("emitplog",{form:data})
                    } else {
                        this.$message.error('请检查表单完整性');
                        return false;
                    }
                });
            },
            close(e){
                this.$emit("emitplog",{})
            },
            appAddCounter: function(e) {
                console.log('子组件传的值：',e)
                this.form.brandid = e['brandid'];
                if(e['seriesid'])this.form.seriesid = e['seriesid']?e['seriesid']:'';
                if(e['modelid'])this.form.modelid = e['modelid']? e['modelid']:'';
            },
        },
        watch:{
        }
    }
</script>

<style scoped lang="scss">
    .el-select{
        width: 100%;
    }
</style>
<style>
    .el-cascader--small{
        width: 100% !important;
    }
</style>
